/* Motionfluid - Assembler SVG parametrico v2 (detalle fiel a fotos de catalogo)
 * buildAssemblySVG(parts, opts) -> string SVG del ensamble completo
 * buildFittingSVG(part, opts)   -> string SVG de UNA conexion de perfil (para slots)
 * parts: [{ role:'fitA'|'fitB'|'adpA'|'adpB', angle:'recta'|'45'|'90', gender:'macho'|'hembra'|null }]
 *
 * v2: geometria basada en las fotos reales (Aeroquip 1AA/1A25):
 *  - ferrula de crimp tipo CAMPANA lisa y pulida (hombro redondeado hacia la manguera,
 *    ligera conicidad, marcas de ponchado sutiles), NO cilindro con ranuras.
 *  - cuello con ranura de alivio entre campana y tuerca.
 *  - tuerca hexagonal giratoria con facetas, biseles y textura de maquinado.
 *  - codos 45/90 como TUBO DOBLADO suave de radio generoso (no nudillo de bola).
 *  - rosca macho con hilos finos y punta biselada.
 * Acentos azul Motionfluid (#0093e9->#2bc4f0) sutiles: o-ring y banda del cuello.
 */
(function (root) {
  'use strict';

  var G = {
    hoseR: 23,        // radio exterior manguera
    shellR: 26.5,     // radio maximo campana de crimp
    shellLen: 47,     // largo campana
    stepLen: 4,       // escalon campana->cuello
    stepR: 19,
    neckR: 12.5,      // cuello entre campana y tuerca
    neckLen: 11,
    nutHalf: 25,      // media altura tuerca (a traves de esquinas)
    nutW: 37,         // espesor tuerca a lo largo del eje
    threadR: 13.5,    // rosca macho
    threadLen: 34,
    tubeR: 12.5,      // radio del tubo del codo
    bendR: 30,        // radio del doblez
    adpNutW: 27,
    adpNutHalf: 21,
    adpThreadLen: 24,
    adpThreadR: 12.5
  };

  function n(v) { return Math.round(v * 100) / 100; }

  // rayado de torno estilo grabado de catalogo: vetas horizontales deterministas
  function lathe(x0, x1, r, k) {
    var m = '', w = x1 - x0;
    if (w < 8) return m;
    var count = Math.max(6, Math.round(r * 0.9));
    for (var i = 0; i < count; i++) {
      var t = (Math.sin((i + 1) * 12.9898 + (k || 0) * 78.233) + 1) / 2;   // pseudo-aleatorio estable
      var t2 = (Math.sin((i + 7) * 39.346 + (k || 0) * 11.135) + 1) / 2;
      var y = -r * 0.9 + (i / (count - 1)) * r * 1.8;
      var lx = x0 + 2 + t * w * 0.35;
      var lw = Math.max(4, w * (0.25 + t2 * 0.55));
      if (lx + lw > x1 - 2) lw = x1 - 2 - lx;
      if (lw < 3) continue;
      var light = y < -r * 0.1;
      var op = light ? (0.05 + t2 * 0.16) : (0.04 + t2 * 0.12);
      var col = light ? '255,255,255' : '10,14,18';
      m += '<line x1="' + n(lx) + '" y1="' + n(y) + '" x2="' + n(lx + lw) + '" y2="' + n(y) + '" stroke="rgba(' + col + ',' + op.toFixed(2) + ')" stroke-width="0.9"/>';
    }
    return m;
  }

  /* ---------- primitivas de sombreado ---------- */

  // cilindro horizontal con sombreado vertical (acero)
  function cyl(x0, x1, r, grad, rx) {
    var w = x1 - x0;
    if (rx == null) rx = Math.min(6, r * 0.45);
    var s = '<rect x="' + n(x0) + '" y="' + n(-r) + '" width="' + n(w) + '" height="' + n(2 * r) + '" rx="' + n(rx) + '" fill="url(#' + grad + ')"/>';
    s += '<rect x="' + n(x0) + '" y="' + n(-r) + '" width="' + n(w) + '" height="1.3" fill="rgba(255,255,255,.30)"/>';
    s += '<rect x="' + n(x0) + '" y="' + n(r - 1.3) + '" width="' + n(w) + '" height="1.3" fill="rgba(4,10,18,.26)"/>';
    s += '<rect x="' + n(x0 + 2) + '" y="' + n(-r * 0.74) + '" width="' + n(Math.max(2, w - 4)) + '" height="' + n(r * 0.5) + '" rx="' + n(r * 0.22) + '" fill="url(#ab-sheenV)" opacity="0.85"/>';
    s += lathe(x0, x1, r, r + x0);
    return s;
  }

  /* ---------- socket/ferrula de crimp (fiel a Aeroquip: cilindro achaparrado,
     facetas de ponchado marcadas tipo prisma hexagonal, filo dentado que muerde la manguera) ---------- */
  function socketFerrule(x0) {
    var R = G.shellR, L = G.shellLen;
    var bodyR = R - 1;
    var m = '';
    // sombra de contacto bajo el cuerpo
    m += '<rect x="' + n(x0 - 1) + '" y="' + n(-bodyR - 1) + '" width="' + n(L + 3) + '" height="' + n(2 * bodyR + 2) + '" rx="6" fill="rgba(8,14,22,.4)"/>';

    // --- filo DENTADO que muerde la manguera (seña de estas conexiones) ---
    var teeth = 9, th = (2 * bodyR) / teeth, saw = '';
    for (var i = 0; i < teeth; i++) {
      var yt = -bodyR + i * th;
      saw += 'M ' + n(x0 + 3) + ' ' + n(yt) + ' L ' + n(x0 - 6) + ' ' + n(yt + th * 0.5) + ' L ' + n(x0 + 3) + ' ' + n(yt + th) + ' Z ';
    }
    m += '<path d="' + saw + '" fill="url(#ab-steel2)" stroke="rgba(12,18,26,.6)" stroke-width="0.7" stroke-linejoin="round"/>';
    // sombra en la garganta de cada diente
    m += '<path d="' + saw + '" fill="rgba(10,16,24,.16)"/>';

    // --- cuerpo cilindrico del socket ---
    m += '<rect x="' + n(x0) + '" y="' + n(-bodyR) + '" width="' + n(L) + '" height="' + n(2 * bodyR) + '" rx="5" fill="url(#ab-shell)" stroke="rgba(14,20,26,.62)" stroke-width="1.3"/>';

    // --- facetas de ponchado VERTICALES marcadas (look prisma de catalogo) ---
    var nf = 6, fw = L / nf;
    for (var f = 1; f < nf; f++) {
      var fx = x0 + f * fw;
      // surco oscuro entre facetas
      m += '<line x1="' + n(fx) + '" y1="' + n(-bodyR + 1.5) + '" x2="' + n(fx) + '" y2="' + n(bodyR - 1.5) + '" stroke="rgba(8,14,22,.5)" stroke-width="2.2"/>';
      // filo de luz de la faceta siguiente
      m += '<line x1="' + n(fx + 1.8) + '" y1="' + n(-bodyR + 2) + '" x2="' + n(fx + 1.8) + '" y2="' + n(bodyR - 2) + '" stroke="rgba(255,255,255,.42)" stroke-width="1.1"/>';
    }
    // brillo central curvo de cada faceta (cada cara del prisma capta la luz)
    for (var f2 = 0; f2 < nf; f2++) {
      var cxf = x0 + f2 * fw + fw * 0.52;
      m += '<rect x="' + n(cxf - fw * 0.17) + '" y="' + n(-bodyR * 0.7) + '" width="' + n(fw * 0.34) + '" height="' + n(bodyR * 0.62) + '" rx="' + n(fw * 0.14) + '" fill="url(#ab-sheenV)" opacity="0.6"/>';
      // micro-sombra al borde de la faceta
      m += '<rect x="' + n(cxf + fw * 0.28) + '" y="' + n(-bodyR * 0.86) + '" width="' + n(fw * 0.16) + '" height="' + n(bodyR * 1.72) + '" rx="1.5" fill="rgba(20,30,42,.08)"/>';
    }
    // filo de luz superior + sombra inferior a lo largo del socket
    m += '<rect x="' + n(x0 + 2) + '" y="' + n(-bodyR) + '" width="' + n(L - 4) + '" height="1.8" fill="rgba(255,255,255,.55)"/>';
    m += '<rect x="' + n(x0 + 2) + '" y="' + n(bodyR - 1.8) + '" width="' + n(L - 4) + '" height="1.8" fill="rgba(4,10,18,.42)"/>';

    // anillos de alivio (collar liso brillante) en cada extremo del socket
    [x0 + 3.5, x0 + L - 6].forEach(function (gx) {
      m += '<rect x="' + n(gx) + '" y="' + n(-bodyR) + '" width="2.6" height="' + n(2 * bodyR) + '" fill="rgba(8,14,22,.34)"/>';
      m += '<rect x="' + n(gx + 2.6) + '" y="' + n(-bodyR) + '" width="1.2" height="' + n(2 * bodyR) + '" fill="rgba(255,255,255,.45)"/>';
    });
    return m;
  }

  // escalon + cuello con ranura de alivio y banda azul fina
  function neck(x0) {
    var m = '';
    var xs = x0, xe = x0 + G.stepLen;
    m += cyl(xs, xe, G.stepR, 'ab-steel2', 2);
    var nx0 = xe, nx1 = xe + G.neckLen;
    m += cyl(nx0, nx1, G.neckR, 'ab-steel2', 2.5);
    // ranura de alivio
    m += '<rect x="' + n(nx0 + 2.5) + '" y="' + n(-G.neckR) + '" width="2" height="' + n(2 * G.neckR) + '" fill="rgba(10,16,24,.45)"/>';
    // segunda ranura de maquinado + filo de luz (neutro, estilo catalogo)
    m += '<rect x="' + n(nx0 + 6) + '" y="' + n(-G.neckR) + '" width="1.6" height="' + n(2 * G.neckR) + '" fill="rgba(10,14,18,.38)"/>';
    m += '<rect x="' + n(nx0 + 7.6) + '" y="' + n(-G.neckR) + '" width="1" height="' + n(2 * G.neckR) + '" fill="rgba(255,255,255,.3)"/>';
    return m;
  }

  /* ---------- tuerca hexagonal (vista de perfil: 3 facetas) ---------- */
  function hexNut(x0, w, half) {
    var x1 = x0 + w;
    var chf = Math.min(8, w * 0.2);
    var fh = half * 0.5; // media altura de la cara frontal
    var m = '';
    // cuerpo con chaflanes
    m += '<path d="M ' + n(x0 + chf) + ' ' + n(-half) + ' L ' + n(x1 - chf) + ' ' + n(-half) +
      ' L ' + n(x1) + ' ' + n(-half + chf) + ' L ' + n(x1) + ' ' + n(half - chf) +
      ' L ' + n(x1 - chf) + ' ' + n(half) + ' L ' + n(x0 + chf) + ' ' + n(half) +
      ' L ' + n(x0) + ' ' + n(half - chf) + ' L ' + n(x0) + ' ' + n(-half + chf) + ' Z" fill="url(#ab-steel)" stroke="rgba(16,20,24,.62)" stroke-width="1.2"/>';
    // faceta superior (mas oscura) y arista
    m += '<path d="M ' + n(x0 + chf) + ' ' + n(-half) + ' L ' + n(x1 - chf) + ' ' + n(-half) + ' L ' + n(x1) + ' ' + n(-half + chf) + ' L ' + n(x1) + ' ' + n(-fh) + ' L ' + n(x0) + ' ' + n(-fh) + ' L ' + n(x0) + ' ' + n(-half + chf) + ' Z" fill="rgba(20,30,42,.28)"/>';
    // faceta inferior (mas oscura aun)
    m += '<path d="M ' + n(x0) + ' ' + n(fh) + ' L ' + n(x1) + ' ' + n(fh) + ' L ' + n(x1) + ' ' + n(half - chf) + ' L ' + n(x1 - chf) + ' ' + n(half) + ' L ' + n(x0 + chf) + ' ' + n(half) + ' L ' + n(x0) + ' ' + n(half - chf) + ' Z" fill="rgba(8,16,26,.4)"/>';
    // cara frontal brillante
    m += '<rect x="' + n(x0) + '" y="' + n(-fh) + '" width="' + n(w) + '" height="' + n(2 * fh) + '" fill="url(#ab-hex)"/>';
    // aristas
    m += '<line x1="' + n(x0) + '" y1="' + n(-fh) + '" x2="' + n(x1) + '" y2="' + n(-fh) + '" stroke="rgba(255,255,255,.45)" stroke-width="1"/>';
    m += '<line x1="' + n(x0) + '" y1="' + n(fh) + '" x2="' + n(x1) + '" y2="' + n(fh) + '" stroke="rgba(6,12,20,.5)" stroke-width="1.1"/>';
    // brillo de cara + cepillado HORIZONTAL fino (maquinado real de la cara del hex)
    m += '<rect x="' + n(x0 + 2) + '" y="' + n(-fh * 0.72) + '" width="' + n(w - 4) + '" height="' + n(fh * 0.5) + '" rx="2.5" fill="url(#ab-sheenV)" opacity="0.7"/>';
    var ty = -fh * 0.85;
    while (ty < fh * 0.85) {
      m += '<line x1="' + n(x0 + 1.5) + '" y1="' + n(ty) + '" x2="' + n(x1 - 1.5) + '" y2="' + n(ty) + '" stroke="rgba(30,42,56,.055)" stroke-width="0.8"/>';
      ty += 3.2;
    }
    // banda especular vertical dura (reflejo de ventana, como en foto de producto)
    m += '<rect x="' + n(x0 + w * 0.16) + '" y="' + n(-half * 0.96) + '" width="' + n(w * 0.1) + '" height="' + n(half * 1.92) + '" fill="rgba(255,255,255,.34)" rx="2"/>';
    m += '<rect x="' + n(x0 + w * 0.3) + '" y="' + n(-half * 0.96) + '" width="' + n(w * 0.045) + '" height="' + n(half * 1.92) + '" fill="rgba(255,255,255,.16)" rx="2"/>';
    // chaflanes de esquina iluminados + sombra de contacto en la base de esquinas
    m += '<line x1="' + n(x0 + chf) + '" y1="' + n(-half) + '" x2="' + n(x0) + '" y2="' + n(-half + chf) + '" stroke="rgba(255,255,255,.5)" stroke-width="1.3"/>';
    m += '<line x1="' + n(x1 - chf) + '" y1="' + n(-half) + '" x2="' + n(x1) + '" y2="' + n(-half + chf) + '" stroke="rgba(255,255,255,.34)" stroke-width="1.2"/>';
    m += '<line x1="' + n(x0 + chf) + '" y1="' + n(half) + '" x2="' + n(x0) + '" y2="' + n(half - chf) + '" stroke="rgba(4,10,18,.4)" stroke-width="1.2"/>';
    m += '<line x1="' + n(x1 - chf) + '" y1="' + n(half) + '" x2="' + n(x1) + '" y2="' + n(half - chf) + '" stroke="rgba(4,10,18,.34)" stroke-width="1.2"/>';
    return m;
  }

  /* ---------- tuerca giratoria MOLETEADA (barril redondo con knurl vertical fino) ---------- */
  function swivelNut(x0, w, half) {
    var r = half;
    var m = '';
    // sombra bajo el barril
    m += '<rect x="' + n(x0 - 0.5) + '" y="' + n(-r - 0.5) + '" width="' + n(w + 1) + '" height="' + n(2 * r + 1) + '" rx="' + n(Math.min(11, r * 0.6)) + '" fill="rgba(8,14,22,.4)"/>';
    // cuerpo redondeado
    m += '<rect x="' + n(x0) + '" y="' + n(-r) + '" width="' + n(w) + '" height="' + n(2 * r) + '" rx="' + n(Math.min(10, r * 0.55)) + '" fill="url(#ab-steel)" stroke="rgba(14,20,26,.6)" stroke-width="1.2"/>';
    // moleteado: pares de lineas verticales finas (grabado tipo diamante en catalogo)
    var step = 2.5;
    for (var x = x0 + 3; x < x0 + w - 2; x += step) {
      m += '<line x1="' + n(x) + '" y1="' + n(-r * 0.86) + '" x2="' + n(x) + '" y2="' + n(r * 0.86) + '" stroke="rgba(10,16,24,.34)" stroke-width="0.8"/>';
      m += '<line x1="' + n(x + 1) + '" y1="' + n(-r * 0.82) + '" x2="' + n(x + 1) + '" y2="' + n(r * 0.82) + '" stroke="rgba(255,255,255,.3)" stroke-width="0.6"/>';
    }
    // filos de luz/sombra + brillo especular central
    m += '<rect x="' + n(x0 + 1) + '" y="' + n(-r) + '" width="' + n(w - 2) + '" height="1.5" fill="rgba(255,255,255,.55)"/>';
    m += '<rect x="' + n(x0 + 1) + '" y="' + n(r - 1.5) + '" width="' + n(w - 2) + '" height="1.5" fill="rgba(4,10,18,.4)"/>';
    m += '<rect x="' + n(x0 + 2) + '" y="' + n(-r * 0.64) + '" width="' + n(w - 4) + '" height="' + n(r * 0.42) + '" rx="3" fill="url(#ab-sheenV)" opacity="0.5"/>';
    // collar liso (sin knurl) en los extremos
    m += '<rect x="' + n(x0) + '" y="' + n(-r) + '" width="2.6" height="' + n(2 * r) + '" rx="1.2" fill="url(#ab-steel2)"/>';
    m += '<rect x="' + n(x0 + w - 2.6) + '" y="' + n(-r) + '" width="2.6" height="' + n(2 * r) + '" rx="1.2" fill="url(#ab-steel2)"/>';
    return m;
  }

  /* ---------- boca hembra (tuerca giratoria con rosca interior) ---------- */
  function femaleMouth(xFace, half) {
    var ry = half * 0.7;
    var m = '';
    m += '<ellipse cx="' + n(xFace) + '" cy="0" rx="4.2" ry="' + n(half * 0.84) + '" fill="url(#ab-steel2)"/>';
    // filo pulido del borde de la boca
    m += '<ellipse cx="' + n(xFace) + '" cy="0" rx="4.2" ry="' + n(half * 0.84) + '" fill="none" stroke="rgba(255,255,255,.4)" stroke-width="0.8"/>';
    m += '<ellipse cx="' + n(xFace + 1.4) + '" cy="0" rx="6" ry="' + n(ry) + '" fill="url(#ab-bore)"/>';
    // cono de asiento 37 grados (flare JIC) insinuado dentro del bore
    m += '<ellipse cx="' + n(xFace + 1.8) + '" cy="0" rx="4.6" ry="' + n(ry * 0.8) + '" fill="none" stroke="rgba(120,140,158,.5)" stroke-width="1.1"/>';
    m += '<ellipse cx="' + n(xFace + 2.6) + '" cy="0" rx="3" ry="' + n(ry * 0.52) + '" fill="none" stroke="rgba(70,86,100,.6)" stroke-width="1"/>';
    m += '<ellipse cx="' + n(xFace + 3.1) + '" cy="0" rx="1.9" ry="' + n(ry * 0.3) + '" fill="rgba(2,5,9,.85)"/>';
    // hilos interiores insinuados (2 anillos)
    m += '<ellipse cx="' + n(xFace + 2.2) + '" cy="0" rx="3.8" ry="' + n(ry * 0.7) + '" fill="none" stroke="rgba(150,168,186,.36)" stroke-width="0.9"/>';
    m += '<ellipse cx="' + n(xFace + 0.6) + '" cy="0" rx="5.2" ry="' + n(ry * 0.88) + '" fill="none" stroke="rgba(6,12,20,.55)" stroke-width="0.9"/>';
    // ranura de o-ring (neutra, como el dibujo tecnico)
    m += '<ellipse cx="' + n(xFace - 2.2) + '" cy="0" rx="3" ry="' + n(ry + 2) + '" fill="none" stroke="rgba(30,36,42,.5)" stroke-width="2.2"/>';
    m += '<ellipse cx="' + n(xFace - 3.2) + '" cy="0" rx="2.3" ry="' + n(ry + 1) + '" fill="none" stroke="rgba(255,255,255,.45)" stroke-width="0.9"/>';
    return m;
  }

  /* ---------- rosca macho estilo catalogo: dientes de sierra en la silueta + cono JIC ---------- */
  function maleThread(x0, len, r) {
    var x1 = x0 + len;
    var coneL = 6.5;                 // cono de asiento 37 (JIC) en la punta
    var tEnd = x1 - coneL;           // fin de la zona roscada
    var rc = r - 2.1;                // radio de raiz (nucleo)
    var m = '';
    // nucleo de la rosca (cilindro al radio de raiz)
    m += '<rect x="' + n(x0) + '" y="' + n(-rc) + '" width="' + n(tEnd - x0) + '" height="' + n(2 * rc) + '" fill="url(#ab-steel2)"/>';
    // dientes de sierra ARRIBA y ABAJO (la silueta real del dibujo de catalogo)
    var pitch = 4.4, xx = x0 + 1.5;
    var top = '', bot = '';
    while (xx + pitch <= tEnd - 0.5) {
      var xm = xx + pitch * 0.5;
      top += 'M ' + n(xx) + ' ' + n(-rc) + ' L ' + n(xm) + ' ' + n(-r) + ' L ' + n(xx + pitch) + ' ' + n(-rc) + ' Z ';
      bot += 'M ' + n(xx) + ' ' + n(rc) + ' L ' + n(xm) + ' ' + n(r) + ' L ' + n(xx + pitch) + ' ' + n(rc) + ' Z ';
      xx += pitch;
    }
    m += '<path d="' + top + '" fill="url(#ab-steel2)" stroke="rgba(20,24,28,.55)" stroke-width="0.7" stroke-linejoin="round"/>';
    m += '<path d="' + bot + '" fill="url(#ab-steel2)" stroke="rgba(20,24,28,.55)" stroke-width="0.7" stroke-linejoin="round"/>';
    // flancos: helice interior (raiz oscura + cresta con luz) sobre el nucleo
    var x2 = x0 + 2.2;
    while (x2 < tEnd - 2.5) {
      m += '<path d="M ' + n(x2) + ' ' + n(-rc + 0.6) + ' Q ' + n(x2 + 2.4) + ' 0 ' + n(x2 + 1.8) + ' ' + n(rc - 0.6) + '" fill="none" stroke="rgba(12,16,22,.42)" stroke-width="1.4"/>';
      m += '<path d="M ' + n(x2 - 1.2) + ' ' + n(-rc + 0.6) + ' Q ' + n(x2 + 1) + ' 0 ' + n(x2 + 0.5) + ' ' + n(rc - 0.6) + '" fill="none" stroke="rgba(255,255,255,.4)" stroke-width="0.8"/>';
      x2 += pitch;
    }
    // sombreado cilindrico del conjunto roscado
    m += '<rect x="' + n(x0) + '" y="' + n(-rc) + '" width="' + n(tEnd - x0) + '" height="' + n(rc * 0.55) + '" fill="url(#ab-sheenV)" opacity="0.5"/>';
    m += '<rect x="' + n(x0) + '" y="' + n(rc * 0.45) + '" width="' + n(tEnd - x0) + '" height="' + n(rc * 0.55) + '" fill="rgba(10,14,18,.18)"/>';
    // cono de asiento (nariz JIC 37): del final de rosca a la punta
    var noseR = r * 0.5;
    m += '<path d="M ' + n(tEnd) + ' ' + n(-rc) + ' L ' + n(x1 - 0.8) + ' ' + n(-noseR) + ' L ' + n(x1 - 0.8) + ' ' + n(noseR) + ' L ' + n(tEnd) + ' ' + n(rc) + ' Z" fill="url(#ab-shell)" stroke="rgba(20,24,28,.45)" stroke-width="0.7"/>';
    // linea de luz del cono + boca
    m += '<path d="M ' + n(tEnd + 0.8) + ' ' + n(-rc * 0.7) + ' L ' + n(x1 - 1.6) + ' ' + n(-noseR * 0.62) + '" stroke="rgba(255,255,255,.5)" stroke-width="0.9" fill="none"/>';
    m += '<ellipse cx="' + n(x1 - 0.8) + '" cy="0" rx="1.5" ry="' + n(noseR) + '" fill="url(#ab-steel2)"/>';
    m += '<ellipse cx="' + n(x1 - 0.8) + '" cy="0" rx="1" ry="' + n(noseR * 0.55) + '" fill="url(#ab-bore)"/>';
    return m;
  }

  /* ---------- codo: tubo doblado suave (como la foto del 1A25DSB16) ---------- */
  // arco desde (sx,0) tangente +x, doblando hacia arriba 'deg' grados, radio bendR.
  // devuelve { markup, ex, ey } (punto final en el marco local)
  function bentTube(sx, deg) {
    var a = deg * Math.PI / 180;
    var R = G.bendR, r = G.tubeR;
    var cx = sx, cy = -R; // centro del arco
    var ex = cx + R * Math.sin(a);
    var ey = cy + R * Math.cos(a);
    var large = 0, sweep = 0; // sentido antihorario (hacia arriba)
    var d = 'M ' + n(sx) + ' 0 A ' + n(R) + ' ' + n(R) + ' 0 ' + large + ' ' + sweep + ' ' + n(ex) + ' ' + n(ey);
    var m = '';
    // arco a un factor de radio (kr = fraccion de r respecto a la fibra neutra), acortado por af
    function arc(kr, af) {
      var RR = R + kr * r, aa = a * af;
      return 'M ' + n(cx + RR * Math.sin(0)) + ' ' + n(cy + RR) + ' A ' + n(RR) + ' ' + n(RR) + ' 0 0 0 ' +
        n(cx + RR * Math.sin(aa)) + ' ' + n(cy + RR * Math.cos(aa));
    }
    // sombra exterior del tubo
    m += '<path d="' + d + '" fill="none" stroke="rgba(8,14,20,.5)" stroke-width="' + n(2 * r + 3) + '" stroke-linecap="round"/>';
    // cuerpo base OSCURO (cromo solido, no glaseado)
    m += '<path d="' + d + '" fill="none" stroke="#464d55" stroke-width="' + n(2 * r) + '" stroke-linecap="round"/>';
    // filo interior oscuro (reflejo del entorno bajo el tubo)
    m += '<path d="' + arc(-0.74, 0.9) + '" fill="none" stroke="rgba(6,10,16,.55)" stroke-width="' + n(r * 0.5) + '" stroke-linecap="round"/>';
    // banda media iluminada (mitad exterior/superior del tubo)
    m += '<path d="' + arc(0.28, 0.9) + '" fill="none" stroke="#aab4bd" stroke-width="' + n(r * 0.95) + '" stroke-linecap="round"/>';
    // banda clara
    m += '<path d="' + arc(0.5, 0.88) + '" fill="none" stroke="#e2e7eb" stroke-width="' + n(r * 0.42) + '" stroke-linecap="round"/>';
    // veta especular dura (reflejo cromo)
    m += '<path d="' + arc(0.62, 0.85) + '" fill="none" stroke="#ffffff" stroke-width="' + n(r * 0.16) + '" stroke-linecap="round" opacity="0.9"/>';
    return { markup: m, ex: ex, ey: ey };
  }

  /* ---------- construccion de un lado (marco local: crimp en 0, apunta +x) ---------- */
  function buildSide(fitting, adapter) {
    var deg = fitting.angle === '90' ? 90 : (fitting.angle === '45' ? 45 : 0);
    var a = deg * Math.PI / 180;

    var m = '';
    m += socketFerrule(0);
    var xNeckEnd = G.shellLen + G.stepLen + G.neckLen;
    m += neck(G.shellLen);

    // cadena de cabeza (tuerca + boca/rosca [+ adaptador]) en marco recto, u desde 0
    var head = '';
    var u = 0;
    var headHalf = G.nutHalf;
    head += hexNut(u, G.nutW, G.nutHalf);
    u += G.nutW;
    if (adapter) {
      head += '<rect x="' + n(u) + '" y="' + n(-G.nutHalf * 0.66) + '" width="2.2" height="' + n(G.nutHalf * 1.32) + '" fill="rgba(10,16,24,.5)"/>';
      var ax0 = u + 2.2;
      head += hexNut(ax0, G.adpNutW, G.adpNutHalf);
      u = ax0 + G.adpNutW;
      if (adapter.gender === 'hembra') {
        var aswW = 16, aswHalf = G.adpNutHalf * 0.94;
        head += swivelNut(u, aswW, aswHalf); u += aswW;
        head += femaleMouth(u + 3, aswHalf); u += 3;
      }
      else { head += maleThread(u, G.adpThreadLen, G.adpThreadR); u += G.adpThreadLen; }
    } else if (fitting.gender === 'macho') {
      head += maleThread(u, G.threadLen, G.threadR);
      u += G.threadLen;
    } else {
      var swW = 21, swHalf = G.nutHalf * 0.92;
      head += swivelNut(u, swW, swHalf); u += swW;
      head += femaleMouth(u + 3, swHalf); u += 3;
    }
    var chainLen = u;

    var footprint, upSpan;
    if (deg === 0) {
      // sombra de contacto de la tuerca sobre el cuello (separacion realista de piezas)
      m += '<rect x="' + n(xNeckEnd - 2.4) + '" y="' + n(-G.neckR) + '" width="2.4" height="' + n(2 * G.neckR) + '" fill="rgba(6,12,20,.38)"/>';
      m += '<g transform="translate(' + n(xNeckEnd) + ',0)">' + head + '</g>';
      footprint = xNeckEnd + chainLen + 6;
      upSpan = Math.max(G.shellR + 2, headHalf + 2);
    } else {
      var tube = bentTube(xNeckEnd, deg);
      m += tube.markup;
      // pequeño cuello en el extremo del tubo antes de la tuerca
      m += '<g transform="translate(' + n(tube.ex) + ',' + n(tube.ey) + ') rotate(' + n(-deg) + ')">' +
        cyl(-2, 7, G.neckR, 'ab-steel2', 2.5) +
        '<rect x="4.8" y="' + n(-G.neckR) + '" width="2.2" height="' + n(2 * G.neckR) + '" fill="rgba(6,12,20,.38)"/>' +
        '<g transform="translate(7,0)">' + head + '</g>' +
        '</g>';
      var headAlong = 7 + chainLen;
      footprint = Math.max(xNeckEnd + G.bendR * Math.sin(a) + headAlong * Math.cos(a) + headHalf * Math.sin(a), xNeckEnd + G.tubeR + 4) + 6;
      upSpan = G.bendR * (1 - Math.cos(a)) + headAlong * Math.sin(a) + headHalf * Math.cos(a) + 4;
      upSpan = Math.max(upSpan, G.shellR + 2);
    }
    return { markup: m, footprint: footprint, upSpan: upSpan };
  }

  /* ---------- manguera ---------- */
  function hose(xL, xR) {
    var r = G.hoseR, iw = xR - xL, w = iw + 12;
    var m = '<rect x="' + n(xL - 6) + '" y="' + n(-r) + '" width="' + n(w) + '" height="' + n(2 * r) + '" rx="' + n(r) + '" fill="url(#ab-hose)"/>';
    m += '<rect x="' + n(xL + 2) + '" y="' + n(-r * 0.66) + '" width="' + n(iw - 4) + '" height="' + n(r * 0.42) + '" rx="' + n(r * 0.2) + '" fill="url(#ab-sheenV)" opacity="0.6"/>';
    m += '<rect x="' + n(xL + 8) + '" y="' + n(-r * 0.6) + '" width="' + n(iw - 16) + '" height="2.4" rx="1.2" fill="rgba(255,255,255,.42)"/>';
    m += '<rect x="' + n(xL + 12) + '" y="' + n(-r * 0.84) + '" width="' + n(iw - 24) + '" height="2" rx="1" fill="rgba(120,210,245,.28)"/>';
    m += '<rect x="' + n(xL + 6) + '" y="' + n(r * 0.52) + '" width="' + n(iw - 12) + '" height="1.6" rx="0.8" fill="rgba(255,255,255,.06)"/>';
    // franja "layline" estilo Aeroquip: banda blanca centrada con la marca impresa sobre la manguera
    var bandH = Math.min(13, r * 0.6), bx = xL + 10, bw = iw - 20;
    if (bw > 70) {
      var cx = xL + iw / 2, ls = Math.max(1.5, Math.min(4, bw / 42));
      m += '<rect x="' + n(bx) + '" y="' + n(-bandH / 2) + '" width="' + n(bw) + '" height="' + n(bandH) + '" rx="' + n(bandH / 2) + '" fill="#f5f8fb"/>';
      m += '<rect x="' + n(bx + 1) + '" y="' + n(-bandH / 2) + '" width="' + n(bw - 2) + '" height="1" fill="rgba(255,255,255,.9)"/>';
      m += '<rect x="' + n(bx + 1) + '" y="' + n(bandH / 2 - 1) + '" width="' + n(bw - 2) + '" height="1" fill="rgba(8,16,26,.20)"/>';
      m += '<text x="' + n(cx) + '" y="0" text-anchor="middle" dominant-baseline="central" font-family="Arial, Helvetica, sans-serif" font-weight="700" font-size="' + n(bandH * 0.72) + '" letter-spacing="' + n(ls) + '" fill="#0b2038">AEROQUIP</text>';
    }
    return m;
  }

  /* ---------- defs ---------- */
  function defs() {
    var vg = ' gradientUnits="objectBoundingBox" x1="0" y1="0" x2="0" y2="1"';
    var s = '<defs>';
    // Cromo de alto contraste: banda especular dura + reflejos de "cielo/piso" (look espejo)
    s += '<linearGradient id="ab-steel"' + vg + '><stop offset="0" stop-color="#3f444a"/><stop offset="0.09" stop-color="#9aa0a6"/><stop offset="0.24" stop-color="#eef0f2"/><stop offset="0.38" stop-color="#ffffff"/><stop offset="0.5" stop-color="#f2f4f5"/><stop offset="0.6" stop-color="#c8ccd1"/><stop offset="0.74" stop-color="#84898f"/><stop offset="0.9" stop-color="#4e5358"/><stop offset="1" stop-color="#303439"/></linearGradient>';
    s += '<linearGradient id="ab-steel2"' + vg + '><stop offset="0" stop-color="#43484e"/><stop offset="0.12" stop-color="#898f96"/><stop offset="0.34" stop-color="#dfe2e5"/><stop offset="0.47" stop-color="#fafbfc"/><stop offset="0.58" stop-color="#d0d4d8"/><stop offset="0.76" stop-color="#787e85"/><stop offset="0.92" stop-color="#464b51"/><stop offset="1" stop-color="#33373c"/></linearGradient>';
    // campana pulida tipo espejo: transicion dura entre luz y reflejo oscuro
    s += '<linearGradient id="ab-shell"' + vg + '><stop offset="0" stop-color="#383d43"/><stop offset="0.07" stop-color="#83898f"/><stop offset="0.2" stop-color="#e7eaec"/><stop offset="0.32" stop-color="#ffffff"/><stop offset="0.46" stop-color="#f4f6f7"/><stop offset="0.55" stop-color="#c9cdd2"/><stop offset="0.7" stop-color="#8a9096"/><stop offset="0.72" stop-color="#a3a9af"/><stop offset="0.88" stop-color="#51565c"/><stop offset="1" stop-color="#313539"/></linearGradient>';
    s += '<linearGradient id="ab-hex"' + vg + '><stop offset="0" stop-color="#6c7278"/><stop offset="0.2" stop-color="#d4d8dc"/><stop offset="0.38" stop-color="#fafbfc"/><stop offset="0.5" stop-color="#ffffff"/><stop offset="0.64" stop-color="#d2d6da"/><stop offset="0.84" stop-color="#858b91"/><stop offset="1" stop-color="#575c62"/></linearGradient>';
    s += '<linearGradient id="ab-hose"' + vg + '><stop offset="0" stop-color="#20242a"/><stop offset="0.08" stop-color="#31363d"/><stop offset="0.2" stop-color="#4a515a"/><stop offset="0.3" stop-color="#5a626c"/><stop offset="0.4" stop-color="#3d434b"/><stop offset="0.52" stop-color="#282d33"/><stop offset="0.7" stop-color="#181b20"/><stop offset="0.85" stop-color="#0f1216"/><stop offset="1" stop-color="#070809"/></linearGradient>';
    s += '<linearGradient id="ab-sheenV"' + vg + '><stop offset="0" stop-color="#ffffff" stop-opacity="0.7"/><stop offset="1" stop-color="#ffffff" stop-opacity="0"/></linearGradient>';
    s += '<linearGradient id="ab-glint" gradientUnits="objectBoundingBox" x1="0" y1="0" x2="1" y2="0"><stop offset="0" stop-color="#dff3ff" stop-opacity="0"/><stop offset="0.5" stop-color="#eaf7ff" stop-opacity="0.55"/><stop offset="1" stop-color="#dff3ff" stop-opacity="0"/></linearGradient>';
    s += '<linearGradient id="ab-rim"' + vg + '><stop offset="0" stop-color="#2bc4f0" stop-opacity="0"/><stop offset="1" stop-color="#0093e9" stop-opacity="0.5"/></linearGradient>';
    s += '<linearGradient id="ab-brand"' + vg + '><stop offset="0" stop-color="#57d3f6"/><stop offset="0.5" stop-color="#12a7ee"/><stop offset="1" stop-color="#0078c8"/></linearGradient>';
    s += '<radialGradient id="ab-bore" cx="0.5" cy="0.5" r="0.6"><stop offset="0" stop-color="#05070a"/><stop offset="0.6" stop-color="#151b23"/><stop offset="1" stop-color="#2b333d"/></radialGradient>';
    s += '<filter id="ab-shadow" x="-6%" y="-30%" width="112%" height="170%"><feDropShadow dx="0" dy="6" stdDeviation="6" flood-color="#123049" flood-opacity="0.18"/></filter>';
    s += '</defs>';
    return s;
  }

  function splitParts(parts) {
    var out = { fitA: null, adpA: null, fitB: null, adpB: null };
    (parts || []).forEach(function (p) { if (p && p.role && out.hasOwnProperty(p.role)) out[p.role] = p; });
    if (!out.fitA) out.fitA = { role: 'fitA', angle: 'recta', gender: 'hembra' };
    if (!out.fitB) out.fitB = { role: 'fitB', angle: 'recta', gender: 'hembra' };
    return out;
  }

  /* ---------- API: ensamble completo ---------- */
  function buildAssemblySVG(parts, opts) {
    opts = opts || {};
    var sp = splitParts(parts);
    var sideA = buildSide(sp.fitA, sp.adpA);
    var sideB = buildSide(sp.fitB, sp.adpB);

    var W = 960, margin = 30;
    var Xa = margin + sideA.footprint;
    var Xb = W - margin - sideB.footprint;
    if (Xb - Xa < 140) { var mid = (Xa + Xb) / 2; Xa = mid - 70; Xb = mid + 70; }

    var pad = 20, minHalf = 62;
    var up = Math.max(sideA.upSpan, sideB.upSpan, minHalf);
    var down = Math.max(G.shellR + 6, minHalf);
    var CY = pad + up;
    var H = Math.round(CY + down + pad);

    var svg = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ' + W + ' ' + H + '" preserveAspectRatio="xMidYMid meet" class="ab-svg" role="img" aria-label="Ensamble de manguera">';
    svg += defs();
    svg += '<g transform="translate(0,' + n(CY) + ')" filter="url(#ab-shadow)">';
    svg += hose(Xa, Xb);
    var flowW = 120, travel = (Xb - Xa) + flowW + 20;
    svg += '<rect class="ab-flow" x="' + n(Xa - flowW) + '" y="' + n(-G.hoseR) + '" width="' + n(flowW) + '" height="' + n(2 * G.hoseR) + '" rx="' + n(G.hoseR) + '" fill="url(#ab-glint)" opacity="0" pointer-events="none" style="--ab-travel:' + n(travel) + 'px"/>';
    svg += '<g transform="translate(' + n(Xa) + ',0) scale(-1,1)">' + sideA.markup + '</g>';
    svg += '<g transform="translate(' + n(Xb) + ',0)">' + sideB.markup + '</g>';
    svg += '</g></svg>';
    return svg;
  }

  /* ---------- API: UNA conexion de perfil (para slots del taller) ---------- */
  // part = { angle, gender } (+role opcional). Dibuja con muñon de manguera corto a la izquierda.
  function buildFittingSVG(part, opts) {
    part = part || {};
    opts = opts || {};
    var side = buildSide({ angle: part.angle || 'recta', gender: part.gender || 'hembra' }, null);
    var stub = 26; // muñon de manguera para dar contexto
    var pad = 10;
    var W = stub + side.footprint + pad * 2;
    var up = side.upSpan + pad;
    var down = G.shellR + 8 + pad;
    var H = up + down;
    var svg = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ' + n(W) + ' ' + n(H) + '" preserveAspectRatio="xMidYMid meet" class="ab-svg ab-fit" role="img" aria-label="Conexion">';
    svg += defs();
    svg += '<g transform="translate(' + n(pad) + ',' + n(up) + ')">';
    // muñon de manguera
    svg += '<rect x="0" y="' + n(-G.hoseR) + '" width="' + n(stub + 6) + '" height="' + n(2 * G.hoseR) + '" rx="' + n(G.hoseR * 0.9) + '" fill="url(#ab-hose)"/>';
    svg += '<rect x="3" y="' + n(-G.hoseR * 0.62) + '" width="' + n(stub - 2) + '" height="' + n(G.hoseR * 0.4) + '" rx="4" fill="url(#ab-sheenV)" opacity="0.55"/>';
    svg += '<g transform="translate(' + n(stub) + ',0)">' + side.markup + '</g>';
    svg += '</g></svg>';
    return svg;
  }

  /* ================= v6: ENSAMBLE CON FOTOS REALES =================
   * renderAssemblyPhoto(host, parts, opts): compone la foto real de la manguera
   * (asset mf-hose-real.png, window.MF_HOSE_REAL) con las fotos reales de las
   * conexiones/adaptadores elegidos (parts[n].img = imagen de la variante).
   * - Quita el fondo blanco de cada foto en canvas (flood fill desde los bordes,
   *   no toca blancos interiores como brillos del metal).
   * - Normaliza tamaños por bounding box del contenido (todas las conexiones
   *   salen a la misma altura real, sin importar el zoom de cada foto).
   * - La manguera se estira por tramos (9-slice) para que el logo no se deforme.
   * Si falta una imagen o algo falla (CORS, red), cae al dibujo SVG de siempre.
   */
  var PH_CACHE = {};

  function phLoad(url) {
    return new Promise(function (res, rej) {
      var im = new Image();
      im.crossOrigin = 'anonymous';
      im.onload = function () { res(im); };
      im.onerror = function () { rej(new Error('no cargó ' + url)); };
      im.src = url;
    });
  }

  // foto -> canvas sin fondo blanco exterior, recortado al contenido.
  // REGLA DEL DUENO: NUNCA recortar el producto — la foto se muestra completa;
  // el encaje con la manguera se logra por ESCALA (boca = diametro de manguera)
  // y por punto de union (jx), no cortando pixeles del producto.
  // EXCEPCIONES (esErase, SOLO conexiones), pedidas por el dueno:
  //  - la ESPIGA/varilla del render se borra (en el kit armado va DENTRO de la
  //    manguera): REGLA DEL ESPEJO — la conexion es un solido de revolucion, todo
  //    pixel por encima del espejo de su borde inferior es varilla, no producto.
  //  - si la foto viene INCLINADA (eje de la campana no horizontal, tipico de los
  //    codos 45 serie 1A) se ENDEREZA rotando la imagen completa: si no, la union
  //    con la manguera queda en angulo y se ve dispareja.

  function phBBoxCrop(cv) { // recorta un canvas RGBA a su contenido (alpha>20)
    var w = cv.width, h = cv.height;
    var d = cv.getContext('2d').getImageData(0, 0, w, h).data;
    var x0 = w, x1 = -1, y0 = h, y1 = -1;
    for (var y = 0; y < h; y++) for (var x = 0; x < w; x++) {
      if (d[(y * w + x) * 4 + 3] > 20) {
        if (x < x0) x0 = x; if (x > x1) x1 = x;
        if (y < y0) y0 = y; if (y > y1) y1 = y;
      }
    }
    if (x1 < 0) return cv;
    var o = document.createElement('canvas');
    o.width = x1 - x0 + 1; o.height = y1 - y0 + 1;
    o.getContext('2d').drawImage(cv, x0, y0, o.width, o.height, 0, 0, o.width, o.height);
    return o;
  }

  function phRotate(cv, ang) { // rota el canvas completo (endereza la campana)
    var s = Math.abs(Math.sin(ang)), c = Math.abs(Math.cos(ang));
    var W = Math.ceil(cv.width * c + cv.height * s), H = Math.ceil(cv.width * s + cv.height * c);
    var o = document.createElement('canvas'); o.width = W; o.height = H;
    var g = o.getContext('2d');
    g.translate(W / 2, H / 2); g.rotate(ang);
    g.drawImage(cv, -cv.width / 2, -cv.height / 2);
    return o;
  }

  // mide la campana: corrida vertical contigua mas larga por columna; edgeH = p88
  // del cuarto derecho; jx = ultima columna a diametro pleno (>=0.93 edgeH); boca
  // (mouthH/mouthCY) = medianas de las ~10 columnas hasta jx; slope = pendiente del
  // eje de la campana (minimos cuadrados sobre el tramo de campana) para el tilt.
  function phMeasure(cv) {
    var w = cv.width, h = cv.height;
    var d = cv.getContext('2d', { willReadFrequently: true }).getImageData(0, 0, w, h).data;
    var colRuns = [];
    for (var x = 0; x < w; x++) {
      var best = 0, cur = 0, curS = -1, bestS = -1;
      for (var y = 0; y < h; y++) {
        if (d[(y * w + x) * 4 + 3] > 40) {
          if (cur === 0) curS = y;
          cur++;
          if (cur > best) { best = cur; bestS = curS; }
        } else cur = 0;
      }
      colRuns.push({ h: best, cy: bestS + best / 2 });
    }
    var ex0 = Math.round(w * 0.75);
    var runs = colRuns.slice(ex0).filter(function (r) { return r.h > 3; })
      .slice().sort(function (a, b) { return a.h - b.h; });
    var pick = runs.length ? runs[Math.floor(0.88 * (runs.length - 1))] : null;
    var edgeH = pick ? pick.h : h;
    var jx = w - 1;
    if (pick) { for (var c1 = w - 1; c1 >= 0; c1--) { if (colRuns[c1].h >= edgeH * 0.93) { jx = c1; break; } } }
    var mouthH = 0, mouthCY = h / 2, mr = [];
    for (var c2 = Math.max(0, jx - 10); c2 <= jx; c2++) if (colRuns[c2].h > 3) mr.push(colRuns[c2]);
    if (mr.length) {
      var hs = mr.map(function (r) { return r.h; }).sort(function (a, b) { return a - b; });
      var cys = mr.map(function (r) { return r.cy; }).sort(function (a, b) { return a - b; });
      mouthH = hs[Math.floor(hs.length / 2)];
      mouthCY = cys[Math.floor(cys.length / 2)];
    }
    if (!(mouthH >= edgeH * 0.3)) mouthH = edgeH;
    // pendiente sobre el borde INFERIOR de la campana (la varilla del render va
    // por ARRIBA y torcia el ajuste si se usaba el centro: fotos derechas se
    // "enderezaban" de mas y quedaban chuecas). Solo columnas del CUERPO de la
    // campana (corrida ~= edgeH; las fundidas con varilla quedan fuera por el tope).
    // pendiente = LINEA MEDIA de la campana LIMPIADA POR ESPEJO: el centro crudo
    // lo sesga la varilla (fundida al lomo -> rotaba fotos derechas) y el borde
    // inferior solo no ve la inclinacion real (perspectiva). El espejo respecto a
    // la boca quita la varilla del tope y el centro limpio si mide el tilt.
    // Solo el cuerpo CONTIGUO de la campana (caminando desde jx, max 3x diametro)
    // para que el tubo de un codo no entre al ajuste.
    var pts = [], misses = 0;
    for (var c3 = jx; c3 >= 0; c3--) {
      if (jx - c3 > edgeH * 3.0) break;
      var rr = colRuns[c3];
      if (rr.h >= edgeH * 0.75 && rr.h <= edgeH * 1.65) {
        var tRaw = rr.cy - rr.h / 2, bRaw = rr.cy + rr.h / 2;
        var tClean = Math.max(tRaw, 2 * mouthCY - bRaw - 4);
        pts.push([c3, (tClean + bRaw) / 2]);
        misses = 0;
      }
      else if (++misses > 6) break;
    }
    var slope = 0;
    if (pts.length > 12) {
      var n2 = pts.length, sx = 0, sy = 0, sxx = 0, sxy = 0;
      for (var k = 0; k < n2; k++) { var p2 = pts[k]; sx += p2[0]; sy += p2[1]; sxx += p2[0] * p2[0]; sxy += p2[0] * p2[1]; }
      var den = n2 * sxx - sx * sx;
      if (den !== 0) slope = (n2 * sxy - sx * sy) / den;
    }
    // FALDA/TROMPETA de la boca: en muchos renders el socket termina en una falda
    // acampanada ABIERTA que sigue DESPUÉS de jx como anillo hueco (arco arriba +
    // arco abajo, centro transparente). Se detecta caminando a la derecha de jx
    // mientras haya pixeles FUERA del cilindro de la boca (|y-mouthCY| > mouthH/2+2);
    // la espiga (que va DENTRO del cilindro) no cuenta. trumpetEnd = jx si no hay falda.
    var trumpetEnd = jx;
    var tLimit = Math.min(w - 1, jx + Math.round(edgeH * 0.8));
    var half = mouthH / 2 + 2;
    for (var c4 = jx + 1; c4 <= tLimit; c4++) {
      var found = false;
      for (var y4 = 0; y4 < h; y4++) {
        if (d[(y4 * w + c4) * 4 + 3] > 40 && Math.abs(y4 - mouthCY) > half) { found = true; break; }
      }
      if (found) trumpetEnd = c4; else break;
    }
    return { edgeH: edgeH, jx: jx, mouthH: mouthH, mouthCY: mouthCY, slope: slope, trumpetEnd: trumpetEnd };
  }

  // borra la varilla/espiga con la REGLA DEL ESPEJO (solo hacia ARRIBA; el lado
  // inferior nunca se toca: el tubo de un codo baja de verdad). Tolerancia 2px.
  function phMirrorErase(cv, ay, edgeH) {
    var w = cv.width, h = cv.height;
    var ctx2 = cv.getContext('2d');
    var id2 = ctx2.getImageData(0, 0, w, h), d2 = id2.data;
    ay = Math.max(0, Math.min(h - 1, Math.round(ay)));
    for (var x = 0; x < w; x++) {
      if (d2[(ay * w + x) * 4 + 3] <= 40) continue;
      var t = ay, b = ay;
      while (t > 0 && d2[((t - 1) * w + x) * 4 + 3] > 40) t--;
      while (b < h - 1 && d2[((b + 1) * w + x) * 4 + 3] > 40) b++;
      if (edgeH && (b - t + 1) < edgeH * 0.32) {
        // corrida del eje DELGADA = la varilla cruzando el eje (va por encima del
        // cuello/tubo): se borra entera; lo real en esa columna (tubo del codo,
        // que va separado mas abajo) no se toca
        for (var y0 = t; y0 <= b; y0++) d2[(y0 * w + x) * 4 + 3] = 0;
        continue;
      }
      var keptT = Math.max(t, Math.round(2 * ay - b) - 2);
      for (var y = 0; y < keptT; y++) d2[(y * w + x) * 4 + 3] = 0;
    }
    ctx2.putImageData(id2, 0, 0);
  }

  // borra SOLO la varilla testigo FLOTANTE de los renders de codo, con una regla que
  // NO PUEDE tocar el producto: en cada columna, si por ENCIMA del cuerpo (el run que
  // contiene el eje de la boca) hay otro run SEPARADO por un HUECO transparente real
  // (≥ gapMin px), ese run de arriba es la varilla (el collarín/tubo van pegados al
  // cuerpo, sin hueco) → se borra lo que esté sobre el cuerpo en esa columna. Donde la
  // varilla se pega al cuerpo (sin hueco) NO se toca nada: el producto se queda COMPLETO.
  // opts.paint (debug) pinta de rojo en vez de borrar para auditar qué se quita.
  function phEraseDetachedTop(cv, axisY, mouthH, paint) {
    var w = cv.width, h = cv.height, ctx = cv.getContext('2d');
    var id = ctx.getImageData(0, 0, w, h), d = id.data;
    axisY = Math.max(0, Math.min(h - 1, Math.round(axisY)));
    var gapMin = Math.max(5, Math.round((mouthH || 0) * 0.05));
    for (var x = 0; x < w; x++) {
      if (d[(axisY * w + x) * 4 + 3] <= 40) continue; // sin cuerpo en el eje: no tocar
      var bt = axisY;
      while (bt > 0 && d[((bt - 1) * w + x) * 4 + 3] > 40) bt--; // tope del cuerpo
      var y = bt - 1, gap = 0;
      while (y >= 0 && d[(y * w + x) * 4 + 3] <= 40) { gap++; y--; }
      if (y >= 0 && gap >= gapMin) {
        // run separado por hueco real = varilla flotante → quitar todo sobre el cuerpo
        for (var yy = 0; yy < bt; yy++) {
          var q = (yy * w + x) * 4;
          if (paint) { if (d[q + 3] > 40) { d[q] = 255; d[q + 1] = 0; d[q + 2] = 0; } }
          else d[q + 3] = 0;
        }
      }
    }
    ctx.putImageData(id, 0, 0);
  }

  // CAJA DEL CUERPO junto a la boca: la conexión NO es simétrica al eje del barreno
  // (el collarín ORS/MF acampana MÁS hacia arriba, + la varilla). Anclar la escala y el
  // centro a la BOCA dejaba el cuerpo sobresaliendo arriba y con hueco abajo (reporte del
  // dueño). Aquí se mide el rectángulo real del CUERPO del socket (barril, corridas
  // ≥0.55×edgeH caminando desde jx hasta que aparece el codo) con percentiles robustos
  // (ignora spikes de varilla residual). Con esto la conexión se ESCALA para que su
  // cuerpo quepa en la manguera y se CENTRA — se conecta pareja, SIN recortar nada.
  function phBodyBox(cv, jx, edgeH) {
    var w = cv.width, h = cv.height;
    var d = cv.getContext('2d', { willReadFrequently: true }).getImageData(0, 0, w, h).data;
    var tops = [], bots = [];
    for (var x = Math.min(jx, w - 1); x >= 0 && (jx - x) <= edgeH * 1.4; x--) {
      var best = 0, cur = 0, c0 = -1, t = -1, b = -1;
      for (var y = 0; y < h; y++) {
        if (d[(y * w + x) * 4 + 3] > 40) { if (cur === 0) c0 = y; cur++; if (cur > best) { best = cur; t = c0; b = y; } }
        else cur = 0;
      }
      if (best < edgeH * 0.55) break; // se acabó el barril: empieza el codo/tubo
      tops.push(t); bots.push(b);
    }
    if (tops.length < 4) return null;
    tops.sort(function (a, b2) { return a - b2; });
    bots.sort(function (a, b2) { return a - b2; });
    var bt = tops[Math.floor(0.10 * (tops.length - 1))]; // p10: ignora spikes de varilla
    var bb = bots[Math.floor(0.90 * (bots.length - 1))];
    return { bodyTop: bt, bodyBot: bb, bodyCY: (bt + bb) / 2, bodyH: (bb - bt) };
  }

  // BORDE DERECHO DEL COLLARÍN (la boca del crimpado): caminando a la derecha de jx
  // mientras la silueta siga "gruesa" (≥0.72×edgeH = el labio/cara del crimpado); en
  // cuanto adelgaza es la ESPIGA (el vástago que va DENTRO de la manguera). Se usa para
  // re-dibujar el collarín AL FRENTE de la manguera (crimpado sobre el hule) sin mostrar
  // la espiga. Nada de recortes: solo define hasta dónde va el collarín visible.
  // OJO: hay renders con espiga GORDA (~0.55×edgeH, ej. 1AA4FRB4/FRC4) — con umbral 0.5
  // el caminado se llevaba la espiga entera y su puntita se veía ENCIMA del hule; la cara
  // del crimpado siempre está ≥~0.95×edgeH, así que 0.72 separa limpio cara vs espiga.
  function phCollarEnd(cv, jx, edgeH) {
    var w = cv.width, h = cv.height;
    var d = cv.getContext('2d', { willReadFrequently: true }).getImageData(0, 0, w, h).data;
    var end = jx, misses = 0;
    for (var x = jx + 1; x < w; x++) {
      var best = 0, cur = 0;
      for (var y = 0; y < h; y++) { if (d[(y * w + x) * 4 + 3] > 40) { cur++; if (cur > best) best = cur; } else cur = 0; }
      if (best >= edgeH * 0.72) { end = x; misses = 0; }
      else if (++misses > 2) break;
    }
    return end;
  }

  // mode: 'es' = enderezar + borrar varilla por espejo (SOLO rectas: cuerpo simétrico
  // al eje, el espejo es válido); 'rot' = enderezar + quitar SOLO la varilla flotante
  // separada por hueco (phEraseDetachedTop, por CONECTIVIDAD: no puede tocar producto).
  // NO se intenta quitar la cola fundida de la varilla sobre el collarín: cualquier
  // método geométrico (espejo/recorte) muerde el collarín porque NO es simétrico ahí
  // (v6.10/v6.13/v6.17 mordieron producto). Regla del dueño: JAMÁS deformar el producto,
  // por eso se prefiere dejar la rebabita antes que arriesgar el collarín.
  // falsy = nada (manguera/adaptadores). true = alias de 'es' por compat.
  function phProcess(url, mode) {
    if (mode === true) mode = 'es';
    // resolución CANÓNICA: las plantillas piden las fotos con ?width=400/500 y a 400px
    // el hueco entre la varilla del render y el socket SE CIERRA (la limpieza por
    // conectividad ya no la ve). Todo se procesa a width=600 — la resolución con la
    // que están validados los auditores; así taller y carrito dan el mismo resultado.
    url = String(url).replace(/([?&])width=\d+/, '$1width=600');
    var key = url + (mode === 'es' ? '#es' : mode === 'rot' ? '#rot' : '');
    if (PH_CACHE[key]) return PH_CACHE[key];
    PH_CACHE[key] = phLoad(url).then(function (im) {
      var maxW = 700;
      var sc = Math.min(1, maxW / (im.naturalWidth || 1));
      var w = Math.max(1, Math.round(im.naturalWidth * sc));
      var h = Math.max(1, Math.round(im.naturalHeight * sc));
      var cv = document.createElement('canvas'); cv.width = w; cv.height = h;
      var cx = cv.getContext('2d', { willReadFrequently: true });
      cx.drawImage(im, 0, 0, w, h);
      var id = cx.getImageData(0, 0, w, h), d = id.data, N = w * h;
      var bright = new Uint8Array(N);
      for (var i = 0; i < N; i++) {
        var p = i * 4;
        if (d[p] > 235 && d[p + 1] > 235 && d[p + 2] > 235) bright[i] = 1;
      }
      // flood fill desde los 4 bordes: solo el blanco EXTERIOR se vuelve transparente
      var mark = new Uint8Array(N), stack = [];
      function push(idx) { if (bright[idx] && !mark[idx]) { mark[idx] = 1; stack.push(idx); } }
      for (var x2 = 0; x2 < w; x2++) { push(x2); push((h - 1) * w + x2); }
      for (var y2 = 0; y2 < h; y2++) { push(y2 * w); push(y2 * w + w - 1); }
      while (stack.length) {
        var c = stack.pop(), cyy = (c / w) | 0, cxx = c - cyy * w;
        if (cxx > 0) push(c - 1);
        if (cxx < w - 1) push(c + 1);
        if (cyy > 0) push(c - w);
        if (cyy < h - 1) push(c + w);
      }
      for (var j = 0; j < N; j++) if (mark[j]) d[j * 4 + 3] = 0;
      cx.putImageData(id, 0, 0);

      var out = phBBoxCrop(cv);
      if (out.height < 5 || out.width < 5) throw new Error('foto vacia ' + url);
      var m = phMeasure(out);
      // enderezar fotos inclinadas (solo conexiones): entre ~2 y ~31 grados
      if (mode && Math.abs(m.slope) > 0.035 && Math.abs(m.slope) < 0.6) {
        out = phBBoxCrop(phRotate(out, -Math.atan(m.slope)));
        m = phMeasure(out);
      }
      if (mode === 'es') phMirrorErase(out, m.mouthCY, m.edgeH);
      // codos (mode 'rot'): NO se borra NADA de la foto. phEraseDetachedTop (quitar la
      // varilla) le dejaba una ALETA cortada al tope del collarín (la varilla en estos
      // renders 1A es tenue y fusionada; al quitarla mordía el borde del barril). La foto
      // cruda ya se ve LISA y completa. Regla del dueño: JAMÁS deformar el producto → se
      // deja la foto tal cual y se resuelve todo por ESCALA/POSICIÓN/Z-ORDER, no borrando.
      // caja del cuerpo (para escalar por el cuerpo y centrarlo)
      var bbx = phBodyBox(out, m.jx, m.edgeH);
      return {
        cv: out, edgeH: m.edgeH, edgeCY: m.mouthCY, mouthH: m.mouthH, jx: m.jx, trumpetEnd: m.trumpetEnd,
        collarEnd: phCollarEnd(out, m.jx, m.edgeH),
        bodyH: bbx ? bbx.bodyH : m.mouthH, bodyCY: bbx ? bbx.bodyCY : m.mouthCY
      };
    });
    return PH_CACHE[key];
  }

  // dibuja la manguera estirando solo los tramos de hule (el logo va en tramo fijo)
  function phDrawHose(ctx, hose, x, y, wT, hT) {
    var iw = hose.width, ih = hose.height, sc = hT / ih;
    var SL = [[0, 0.06, 1], [0.06, 0.35, 0], [0.35, 0.72, 1], [0.72, 0.94, 0], [0.94, 1, 1]];
    var fixedW = 0, flexSrc = 0;
    SL.forEach(function (s) { var sw = (s[1] - s[0]) * iw; if (s[2]) fixedW += sw * sc; else flexSrc += sw; });
    var flexT = wT - fixedW;
    if (flexT < 8) { ctx.drawImage(hose, x, y, wT, hT); return; }
    var cur = x;
    SL.forEach(function (s) {
      var sx = s[0] * iw, sw = (s[1] - s[0]) * iw;
      var dw = s[2] ? sw * sc : flexT * (sw / flexSrc);
      ctx.drawImage(hose, sx, 0, sw, ih, cur, y, dw + 0.6, hT); // +0.6 evita costuras
      cur += dw;
    });
  }

  function renderAssemblyPhoto(host, parts, opts) {
    opts = opts || {};
    var hoseUrl = opts.hoseUrl || root.MF_HOSE_REAL;
    var sp = splitParts(parts);
    function fallback() { host.innerHTML = buildAssemblySVG(parts, opts); }
    var ok = hoseUrl && sp.fitA && sp.fitA.img && sp.fitB && sp.fitB.img &&
      (!sp.adpA || sp.adpA.img) && (!sp.adpB || sp.adpB.img);
    if (!ok) { fallback(); return; }
    // rectas: limpieza completa de la varilla del render (espejo válido por simetría);
    // codos (cualquier ángulo): NUNCA borrado espejo — mordía el collarín/tubo reales
    // (regla del dueño: el producto se muestra completo). La punta/espiga que sigue a
    // la boca la tapa la manguera en ambos casos.
    function fitMode(p) {
      var a = String((p && p.angle) || '').toLowerCase();
      return (a && a !== 'recta' && a !== '0') ? 'rot' : 'es';
    }
    Promise.all([
      phProcess(hoseUrl), phProcess(sp.fitA.img, fitMode(sp.fitA)), phProcess(sp.fitB.img, fitMode(sp.fitB)),
      sp.adpA ? phProcess(sp.adpA.img) : null, sp.adpB ? phProcess(sp.adpB.img) : null
    ]).then(function (r) {
      var hose = r[0].cv || r[0], fA = r[1], fB = r[2], aA = r[3], aB = r[4];
      var hoseH = 92;
      // REGLA (ley del dueño, reporte de los codos "sobresalen/desparejos"): la conexión
      // se ESCALA para que su CUERPO (el barril del socket, que acampana más que la boca)
      // quepa dentro de la manguera, y se CENTRA — así se conecta pareja sin que nada
      // sobresalga por arriba/abajo. Ancla = bodyH (alto real del cuerpo), NO la boca
      // (anclar a la boca dejaba el cuerpo asomando). 0.98 = un pelo dentro de la manguera
      // (el hule queda apenas más gordo, como un crimpado real). NO se recorta nada.
      function fitScale(p) {
        return (hoseH * 0.98) / (p.bodyH || p.mouthH || p.edgeH || p.cv.height);
      }
      var sA = fitScale(fA), sB = fitScale(fB);
      // guardia de cordura: proporciones así de grandes = medición de boca fallida
      // (ninguna foto real del catálogo pasa de ~3.8× de alto ni ~5× de largo)
      if (fA.cv.height * sA > hoseH * 6 || fB.cv.height * sB > hoseH * 6 ||
          fA.cv.width * sA > hoseH * 12 || fB.cv.width * sB > hoseH * 12) { fallback(); return; }
      var wA = fA.cv.width * sA, hA = fA.cv.height * sA;
      var wB = fB.cv.width * sB, hB = fB.cv.height * sB;
      var adpH = Math.round(hoseH * 1.18);
      function wOf(p, hh) { return p.cv.width * (hh / p.cv.height); }
      var wAA = aA ? wOf(aA, adpH) : 0, wAB = aB ? wOf(aB, adpH) : 0;
      var margin = 10, thread = 12; // solape adaptador<->rosca de la conexión
      var jxA = (fA.jx != null ? fA.jx : fA.cv.width) * sA;
      var jxB = (fB.jx != null ? fB.jx : fB.cv.width) * sB;
      // lienzo adaptable: espacio de cada lado hasta su boca + manguera visible fija
      var W = Math.max(1000, Math.ceil(margin * 2 + (aA ? wAA - thread : 0) + jxA +
        (aB ? wAB - thread : 0) + (wB - jxB) + 320));
      var xAA = margin;
      var xA = aA ? xAA + wAA - thread : margin;
      var xAB = W - margin - wAB;
      var xB = aB ? xAB + thread - wB : W - margin - wB;
      // unión A TOPE: la manguera empieza justo donde la campana está a diámetro
      // pleno (jx) y se dibuja AL FINAL, tapando la espiga/punta que sigue después
      // (el producto se muestra completo, nada recortado)
      var jA = jxA, jB = jxB;
      var hx0 = xA + jA - 2, hx1 = xB + (wB - jB) + 2;
      if (hx1 - hx0 < 60) { fallback(); return; }
      // eje de la manguera = CENTRO DEL CUERPO del socket (bodyCY), no el de la boca:
      // el cuerpo acampana asimétrico, así que centrarlo por el cuerpo lo deja parejo
      // dentro de la banda de la manguera (arriba y abajo iguales)
      var topA = (fA.bodyCY != null ? fA.bodyCY : fA.edgeCY) * sA, botA = hA - topA;
      var topB = (fB.bodyCY != null ? fB.bodyCY : fB.edgeCY) * sB, botB = hB - topB;
      var top = Math.max(topA, topB, adpH / 2, hoseH / 2) + 13;
      var bot = Math.max(botA, botB, adpH / 2, hoseH / 2) + 13;
      var H = top + bot, cy2 = top;
      var dpr = Math.min(2, (root.devicePixelRatio || 1));
      var cv = document.createElement('canvas');
      cv.width = Math.round(W * dpr); cv.height = Math.round(H * dpr);
      cv.style.width = '100%'; cv.style.maxWidth = W + 'px';
      cv.style.display = 'block'; cv.style.margin = '0 auto';
      cv.className = 'ab-photo';
      var ctx = cv.getContext('2d');
      ctx.scale(dpr, dpr);
      // orden: adaptadores, conexiones COMPLETAS, y la manguera AL FINAL — así la
      // manguera tapa la espiga/punta de cada conexión y la unión queda a tope
      if (aA) ctx.drawImage(aA.cv, xAA, cy2 - adpH / 2, wAA, adpH);
      if (aB) { ctx.save(); ctx.translate(xAB + wAB, 0); ctx.scale(-1, 1); ctx.drawImage(aB.cv, 0, cy2 - adpH / 2, wAB, adpH); ctx.restore(); }
      ctx.drawImage(fA.cv, xA, cy2 - topA, wA, hA);
      ctx.save(); ctx.translate(xB + wB, 0); ctx.scale(-1, 1); ctx.drawImage(fB.cv, 0, cy2 - topB, wB, hB); ctx.restore();
      // la manguera tapa la espiga (el vástago que va DENTRO del hule)
      phDrawHose(ctx, hose, hx0, cy2 - hoseH / 2, hx1 - hx0, hoseH);
      // ...y el COLLARÍN se re-dibuja AL FRENTE de la manguera (crimpado sobre el hule),
      // recortado SOLO hasta collarEnd para NO re-dibujar la espiga (que queda detrás).
      // Es solo DIBUJAR el socket completo otra vez encima — no se borra ni corta nada;
      // arregla que el hule tapara el labio del collarín y se viera "cortado".
      var ceA = xA + (fA.collarEnd != null ? fA.collarEnd : fA.jx) * sA;
      ctx.save(); ctx.beginPath(); ctx.rect(0, 0, ceA, H); ctx.clip();
      ctx.drawImage(fA.cv, xA, cy2 - topA, wA, hA); ctx.restore();
      var ceB = xB + wB - (fB.collarEnd != null ? fB.collarEnd : fB.jx) * sB;
      ctx.save(); ctx.beginPath(); ctx.rect(ceB, 0, W - ceB, H); ctx.clip();
      ctx.translate(xB + wB, 0); ctx.scale(-1, 1); ctx.drawImage(fB.cv, 0, cy2 - topB, wB, hB); ctx.restore();
      host.innerHTML = '';
      host.appendChild(cv);
    }).catch(function (e) {
      try { console.warn('[mf-assembler foto]', e); } catch (_) {}
      fallback();
    });
  }

  root.buildAssemblySVG = buildAssemblySVG;
  root.buildFittingSVG = buildFittingSVG;
  root.renderAssemblyPhoto = renderAssemblyPhoto;
  root.MF_ASM_VERSION = 'foto-v6.23';
})(typeof window !== 'undefined' ? window : this);
